import { Box } from "@mui/material";

import { Faqs } from "src/components/base/components/Faqs";
import { DynamicModal } from "src/components/base/components/DynamicModal";

import { createState } from "src/utils/create_zustand_store";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

type TPrePurchaseFAQModal = {
  isOpen: boolean;
  faqs: TTeamConfig["LANGUAGES"]["FAQS"];
};

export const usePrePurchaseFAQModal = createState<TPrePurchaseFAQModal>({
  isOpen: false,
  faqs: [],
});

export function PrePurchaseFAQModal() {
  const prePurchaseFAQModal = usePrePurchaseFAQModal();

  function onClose() {
    prePurchaseFAQModal.set({ isOpen: false });
  }

  if (!prePurchaseFAQModal?.faqs?.length) return null;

  return (
    <DynamicModal
      hideTitleIcon
      isOpen={prePurchaseFAQModal.isOpen}
      title={"Frequently Asked Questions"}
      renderBody={() => {
        return (
          <Box p={4}>
            <Faqs hideTitle faqs={prePurchaseFAQModal.faqs} />
          </Box>
        );
      }}
      onClose={onClose}
      slot={{
        paper: {
          style: {
            margin: "0 8px",
          },
        },
        primaryButton: {
          label: "Close",
          onClick: onClose,
        },
        secondaryButton: {
          isHidden: true,
        },
      }}
    />
  );
}
